

function  updateTime(k) {
    if (k < 10) {
        return "0" + k;
    }
    else {
        return k;
    }
}

export function getUtcTime  (inputDate,time) {
    
    

    let date = new Date(inputDate +' '+ time);
    return updateTime(date.getUTCFullYear()) + '-' + updateTime((date.getUTCMonth() + 1)) + '-' + updateTime(date.getUTCDate()) + ' ' +
        updateTime(date.getUTCHours()) + ':' + updateTime(date.getUTCMinutes()) + ':' + updateTime(date.getUTCSeconds()) + '';
}